import BaseClass from "../BaseClass";
import ElementsCounter from "./ElementsCounter";
import PriceCounter from "./PriceCounter";

const defaultOptions = {};

/**
 * This class is used for handling searchs.
 */
export default class CounterWrapper extends BaseClass {

    /**
    * Constructor
    * @param options
    */
    constructor(options)
    {
        super(options, defaultOptions);

        window.priceCounters = {};
        window.elementsCounters = {};

        CounterWrapper.init();
    }

    static init(parent)
    {
        $(document).ready(() => {

            $(parent).find('[data-price-counter]').each(function () {
                let counterName = $(this).data('priceCounter');
                window.priceCounters[counterName] = new PriceCounter(counterName);
            });

            $(parent).find('[data-elements-counter]').each(function () {
                let counterName = $(this).data('elementsCounter');
                window.elementsCounters[counterName] = new ElementsCounter(counterName);
            });
        });
    }
}
